<script setup lang="ts">
import DirectionsPage from '../features/directions/DirectionsPage.vue';
</script>

<template>
  <DirectionsPage />
</template>
